export default __webpack_public_path__ + "static/media/Bank-of-Baroda.2a0d8bd0.webp";